module.exports = __webpack_public_path__ + "564322eb1c8b6ee89e968c8e2f12cdcd.svg";